import Card from 'components/card';
import { MdClose } from 'react-icons/md';
import InputField from 'components/fields/InputField';
import Checkbox from 'components/checkbox';
import { useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleLogin } from '@react-oauth/google';

const SignUpModal = (props: { isOpen: boolean; onClose: any }) => {
    const { isOpen, onClose } = props;
    const [error, setError] = useState('');
    const [newUser, setNewUser] = useState({
        name: '',
        surname: '',
        email: '',
        password: '',
        siret: '',
        referal: '',
        company: '',
        type: 'buyer',
        role: 'ceo',
        accept_tos: false,
        phone: '',
    });

    if (!isOpen) return null;

    const loginGoogle = (token: string) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/google`, { ...newUser, token })
            .then((response: any) => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user-type', response.data.type);
                    window.location.href = '/admin/dashboard';
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    };

    const handleChange = (e: any) => {
        const { id, value } = e.target;

        if (id === 'accept_tos') {
            setNewUser((prevState) => ({
                ...prevState,
                [id]: !prevState.accept_tos,
            }));
            return;
        }
        setNewUser((prevState) => ({
            ...prevState,
            [id]: value,
        }));
        setError('');
    };

    const handleSubmit = (e: any) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/register`, newUser)
            .then((res: any) => {
                localStorage.setItem('user-type', newUser.type);
                localStorage.setItem('token', res.data.token);
                if (res.data && res.data.token.length > 10)
                    onClose(true);
            })
            .catch((err: any) => {
                console.log(err.response.data.error);
                setError(err.response.data.error);
            });
    };

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/30 backdrop-blur-sm transition-opacity">
            <div className="relative z-[1002] w-full max-w-[420px] p-4 max-h-[90vh] flex flex-col">
                <Card extra="px-[30px] pt-[35px] pb-[40px] w-full flex flex-col !z-[1004] border shadow-2xl overflow-y-auto">
                    <div className="absolute right-5 top-5">
                        <MdClose
                            size={20}
                            className="cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
                            onClick={() => onClose(false)}
                        />
                    </div>
                    
                    <ToastContainer />
                    <h3 className="mb-2 text-xl font-bold text-navy-700 dark:text-white lg:text-2xl text-center">
                        Rejoindre Leadrs !
                    </h3>
                    <p className="mb-5 text-center text-base text-gray-600">
                        Achat de leads qualifiés à la demande.
                    </p>
                    {error && (
                        <p className="mb-2 text-center text-sm text-red-500">
                            {error}
                        </p>
                    )}
                    
                    {/* Email */}
                    <InputField
                        variant="auth"
                        extra="mb-2 [&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                        label="Email*"
                        placeholder="contact@leadrs.co"
                        id="email"
                        type="email"
                        onChange={handleChange}
                    />

                    {/* Password */}
                    <InputField
                        variant="auth"
                        extra="mb-2 [&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                        label="Mot de passe"
                        placeholder="********"
                        id="password"
                        type="password"
                        onChange={handleChange}
                    />

                    <div className="grid grid-cols-2 gap-2 mb-2">
                        {/* Company */}
                        <InputField
                            variant="auth"
                            extra="[&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                            label="Entreprise*"
                            placeholder="Amazon"
                            id="company"
                            type="text"
                            onChange={handleChange}
                        />

                        {/* Phone */}
                        <InputField
                            variant="auth"
                            extra="[&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                            label="Téléphone"
                            placeholder="+33..."
                            id="phone"
                            type="phone"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Referral */}
                    <InputField
                        variant="auth"
                        extra="mb-2 [&_input]:!h-10 [&_input]:!py-2 [&_input]:!mt-1"
                        label="Code de parrainage"
                        placeholder="RF57834"
                        id="referal"
                        type="text"
                        onChange={handleChange}
                    />
                    
                    {/* Checkbox */}
                    <div className="mt-2 flex items-center justify-between px-2">
                        <div className="flex">
                            <Checkbox
                                id="accept_tos"
                                onClick={handleChange}
                            />
                            <label
                                htmlFor="accept_tos"
                                className="ml-2 text-sm text-gray-700"
                            >
                                En cochant cette case, vous confirmez que
                                vous avez lu, compris et acceptez les{' '}
                                <a
                                    href="/terms"
                                    className="text-blue-600 underline"
                                >
                                    Conditions Générales d’Utilisation
                                </a>
                            </label>
                        </div>
                    </div>
                    
                    <button
                        className="linear mt-4 w-full rounded-xl bg-[#7166fe] py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                        onClick={(e) => handleSubmit(e)}
                    >
                        M'inscrire
                    </button>
                    
                    <div className="mt-5 flex items-center justify-center">
                        <div className="w-full border-t border-gray-300"></div>
                        <span className="mx-2 text-sm text-gray-500">
                            OU
                        </span>
                        <div className="w-full border-t border-gray-300"></div>
                    </div>
                    
                    <div className="mt-4 flex w-full">
                        <GoogleLogin
                            onSuccess={(credentialResponse: any) => {
                                loginGoogle(credentialResponse.credential);
                            }}
                            containerProps={{
                                className: 'w-full',
                            }}
                            shape="circle"
                            size="large"
                            theme="outline"
                            logo_alignment="center"
                            onError={() => {
                                console.log('Login Failed');
                            }}
                        />
                    </div>

                    <div className="mt-3 text-center">
                        <span className="text-sm font-medium text-navy-700 dark:text-gray-500">
                            Déjà inscrit ?
                        </span>
                        <a
                            href="/auth/sign-in/"
                            className="ml-1 text-sm font-medium text-leadrs hover:text-brand-600 dark:text-white"
                        >
                            Se connecter
                        </a>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default SignUpModal;
